import { styled } from '@mui/system'
import { ReactNode, forwardRef } from 'react'

const StyledTooltipWrapper = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  { name: 'TooltipContent', slot: 'mainWrapper' }
)

const StyledImageWrapper = styled('div')(
  {
    height: '100%',
    width: '100%',
    maxHeight: '168px',
    maxWidth: 300,
    borderRadius: 4,
    paddingBottom: '8px',
    display: 'flex',
    justifyContent: 'center',
  },
  { name: 'TooltipContent', slot: 'imageWrapper' }
)

const StyledTextWrapper = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  { name: 'TooltipContent', slot: 'textWrapper' }
)

const StyledTitleWrapper = styled('div')(
  ({ theme }: { theme: any }) => {
    return {
      ...theme.typography.body3SemiBold,
    }
  },
  { name: 'TooltipContent', slot: 'titleInnerWrapper' }
)

const StyledMessageWrapper = styled('div')(
  ({ theme }: { theme: any }) => {
    return {
      ...theme.typography.body3,
    }
  },
  { name: 'TooltipContent', slot: 'messageInnerWrapper' }
)
const StyledLinkWrapper = styled('div')<{ color: string }>(
  ({ theme, color }: { theme: any; color: string }) => ({
    ...theme.typography.body3Medium,
    paddingTop: '8px',
    '& a': {
      color: color === 'secondary' ? `${theme.palette.blue[800]} !important` : theme.palette.common.white,
    },
  }),
  { name: 'TooltipContent', slot: 'linkWrapper' }
)
interface TooltipContentProps {
  title?: ReactNode
  showTitle?: boolean
  message: string
  linkLabel?: string
  linkUrl?: string
  linkExternal?: boolean
  image?: ReactNode
  color: string
}

export const TooltipContent = forwardRef<HTMLDivElement, TooltipContentProps>((props, ref) => {
  void ref
  const { title, showTitle, message, linkLabel, linkUrl, linkExternal, image, color } = props

  // Return null if there's no meaningful content to show
  const hasTitle = title && showTitle && String(title).trim()
  const hasMessage = message && String(message).trim()
  const hasImage = image
  const hasLink = linkLabel && linkUrl

  if (!hasTitle && !hasMessage && !hasImage && !hasLink) {
    return null
  }

  return (
    <StyledTooltipWrapper>
      {image && <StyledImageWrapper>{typeof image === 'string' ? <img src={image} /> : image}</StyledImageWrapper>}

      <StyledTextWrapper>
        {title && showTitle && <StyledTitleWrapper>{title}</StyledTitleWrapper>}
        <StyledMessageWrapper>{message}</StyledMessageWrapper>
      </StyledTextWrapper>

      {linkLabel && linkUrl && (
        <StyledLinkWrapper color={color}>
          {/** The linter is a bit picky here, hence the conditional rendering */}
          {linkExternal ? (
            <a href={linkUrl} target="_blank" rel="noreferrer">
              {linkLabel}
            </a>
          ) : (
            <a href={linkUrl} target="_self">
              {linkLabel}
            </a>
          )}
        </StyledLinkWrapper>
      )}
    </StyledTooltipWrapper>
  )
})
